import styled from '@emotion/styled';
import { Input } from 'antd';
import React from 'react';
import { connect } from 'react-redux';

import { AppState } from 'src/config/appState';
import { StepButtons, StepButtonsProps } from 'src/modules/programs/components/StepButtons';
import * as S from 'src/modules/programs/stepComponents/styles';
import { color, font } from 'src/shared/styles/variables';

import {
    changeFlexibilityPracticeAnswer,
    submitFlexibilityPracticeAnswer,
} from '../actions/weekFourActions';
import { ContentAnswer, ContentQuestion } from '../models/weekFour';
import {
    getFlexibilityPracticeAnswer,
    getFlexibilityPracticeQuestion,
} from '../selectors/weekFourSelectors';

const QuestionHeader = styled('h4')(
    {
        color: color.chathamsBlue,
        lineHeight: 1.5,
    },
    font.heavy(font.size.medium),
);

const StyledTextArea = styled<any>(Input.TextArea)({
    marginTop: '0.44rem',
    '&&.ant-input': {
        maxWidth: '45.50rem',
    },
});

interface StateProps {
    data: ContentQuestion;
    answer: ContentAnswer;
}

interface ActionsProps {
    changeFlexibilityPracticeAnswer: typeof changeFlexibilityPracticeAnswer;
    submitFlexibilityPracticeAnswer: typeof submitFlexibilityPracticeAnswer;
}

type Props = StepButtonsProps & StateProps & ActionsProps;

class FlexibilityPracticeStepContainer extends React.Component<Props> {
    private handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) =>
        this.props.changeFlexibilityPracticeAnswer({ value: e.target.value });

    private handleSubmit = () => {
        const { data, answer } = this.props;

        if (data.answer === '') {
            return;
        }

        this.props.submitFlexibilityPracticeAnswer(answer);
        this.props.goToNextStep();
    };

    public render(): JSX.Element {
        const { data } = this.props;

        return (
            <>
                <S.ContentRow>
                    <S.ContentColumn>
                        <S.StepHeading small>Developing Flexibility with Thoughts</S.StepHeading>
                        <S.StepHeading>Practice</S.StepHeading>
                        <S.StepDescription small>
                            This might be a simple example but it can be really empowering to learn
                            that you have the agency to do whatever you choose, regardless of what
                            your thoughts tell you to do!
                        </S.StepDescription>
                        <S.StepBoxWrapper>
                            <QuestionHeader>{data.text}</QuestionHeader>
                            <StyledTextArea
                                value={data.answer}
                                onChange={this.handleInputChange}
                                size="large"
                                placeholder="E.g. Im too tired to go for a walk"
                            />
                        </S.StepBoxWrapper>
                    </S.ContentColumn>
                </S.ContentRow>
                <StepButtons
                    onPreviousClick={this.props.goToPreviousStep}
                    onNextClick={this.handleSubmit}
                    nextDisabled={data.answer === ''}
                    hasNextStep
                />
            </>
        );
    }
}

const mapStateToProps = (state: AppState): StateProps => ({
    data: getFlexibilityPracticeQuestion(state),
    answer: getFlexibilityPracticeAnswer(state),
});

export const FlexibilityPracticeStep = connect(mapStateToProps, {
    changeFlexibilityPracticeAnswer,
    submitFlexibilityPracticeAnswer,
})(FlexibilityPracticeStepContainer);
